import StepsListController from './stepsListController';

const StepsListComponent = {
    template: require('./stepsListView.html'),
    controller: StepsListController
};

export default StepsListComponent;




// WEBPACK FOOTER //
// ./src/app/pages/evaluation/stepsList/stepsListComponent.js